<script lang="ts">
	import Section from "#lib/web-ui/primitives/section.svelte";
	import CheckCircleIcon from "@lucide/svelte/icons/check-circle-2";
	import type { Snippet } from "svelte";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";

	let {
		children
	}: {
		children: Snippet;
	} = $props();

	const benefits = [
		"No Fees & Commissions",
		"No Showing",
		'Sell Your House "As Is"',
		"Leave Tenants To Us",
		"No Realtors",
		"No Showing",
		"Take The Entire Offer"
	];

	const siteWideBanner = getTemplateContext().siteSlogan;
</script>

<Section
	class="from-primary/60 via-primary/50 to-primary/80/40 relative overflow-hidden bg-gradient-to-br"
>
	<div class="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
		<!-- Left: Form -->
		<div class="space-y-6">
			<div>
				<h2
					class="text-foreground text-4xl font-semibold tracking-tight text-pretty sm:text-5xl"
				>
					Get Your No Obligation<br />Cash Offer
				</h2>
				<p class="mt-6 text-lg/8 text-gray-600">
					We respect your privacy. We will not share, rent or sell the information you
					provide.
				</p>
			</div>

			{@render children?.()}
		</div>

		<!-- Right: Trust/Benefits Panel -->
		<div class="bg-foreground/95 flex flex-col justify-between rounded-2xl p-10 text-white">
			<div class="space-y-4">
				<h3 class="mb-8 text-3xl font-bold">{siteWideBanner}</h3>
				{#each benefits as benefit}
					<div class="flex items-start gap-3">
						<CheckCircleIcon class="text-primary w-8flex-shrink-0 h-8" />
						<p class="text-2xl font-medium">{benefit}</p>
					</div>
				{/each}
			</div>
		</div>
	</div>
</Section>
